module.exports = {
    siteTitle: `Blog`,
    description: `Blog Starter for Gatsby`,
    copyright: 'Copyright © 2020 Built with Gatsby. All Rights Reserved',
    siteLogo: '', // path to logo
    siteUrl: 'https://sleepy-aryabhata-daee42.netlify.com/', // Domain of your website without pathPrefix.
    postsPerPage: 2, // for blog
    // Author Info
    author: `John Doe`,
    // Social Media Info Use URLs
    userTwitter: '',
    userLinkedIn: '',
    userGithub: '',
    userInstragram:'',
    userGooglePlus:'',
    userFaceBook:'',
  }